/**
 * Created by jaime on 10/10/2017.
 */

import Vue from 'vue'
import Vuex from 'vuex'
import account from './account'
import utils from '../utils'
import { vuexfireMutations } from 'vuexfire'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      true: true,
      false: false,
      drawer: null,
  },
  modules: {
    'account': account
  },
  getters: {
     drawer: (state) => state.drawer
  },
  mutations: {
      ...vuexfireMutations,
    drawer(state) {
      state.drawer = !state.drawer
    }
  },
})

Vue.prototype.$utils = utils;
